import { registrarBotonAtras } from './botonAtras';
import { instalarCabecerasDeCliente } from './cabecerasCliente';
import { registrarEnlaces } from './enlaces';
import { ocuparPantallaCompleta } from './pantallaCompleta';
import { noAbrirTecladoAlAbrirDialogos } from './tecladoEnDialogos';
import { seguirTecladoEnPantalla } from './tecladoEnPantalla';
import { evitarZoomAlEscribir } from './zoomAlEscribir';

/**
 * Todo lo que la app instala al arrancar, en una sola llamada desde `index.tsx`. Cada pieza
 * comprueba por su cuenta si está en la app (`esApp`) y, en la web, no hace nada.
 *
 * El orden importa poco, pero se conserva el de siempre: primero la pantalla completa, para que
 * las barras ya se aparten antes de pintar nada.
 */
export const instalarApp = (): void => {
	ocuparPantallaCompleta();
	registrarBotonAtras();
	instalarCabecerasDeCliente();
	evitarZoomAlEscribir();
	registrarEnlaces();
	noAbrirTecladoAlAbrirDialogos();
	seguirTecladoEnPantalla();
};
